import React, { useState, useEffect } from 'react';
import '../styles/Header.css';
import logo_futek from '../assets/futeklogo.png';
import { NavLink } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaXTwitter, FaTiktok, FaInstagram, FaGlobe,FaWhatsapp } from 'react-icons/fa6';
import { FaSearch } from 'react-icons/fa'; // Top of file
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`clarity-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="clarity-logo-section">
        <img src={logo_futek} alt="FU-TEK Logo" className="clarity-logo" />
      </div>

      <div className="right-section">
        <div className="social-row">
          <a href="#"><FaFacebookF /></a>
          <a href="https://www.linkedin.com/in/fu-tek-automation-40316b1a7/"><FaLinkedinIn /></a>
          <a href="https://wa.me/917046062908"><FaWhatsapp /></a>
          <a href=""><FaInstagram /></a>
        </div>

        <div className="nav-search-row">
          <div className={`clarity-nav ${menuOpen ? 'open' : ''}`}>
            {menuOpen && (
  <button className="mobile-close-btn" onClick={toggleMenu} aria-label="Close Menu">
    &times;
  </button>
)}

<NavLink
  to="/"
  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
  onClick={() => setMenuOpen(false)}
>
  <b>Home</b>
</NavLink>

<NavLink
  to="/about"
  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
  onClick={() => setMenuOpen(false)}
>
  <b>About Us</b>
</NavLink>

<NavLink
  to="/products"
  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
  onClick={() => setMenuOpen(false)}
>
  <b>Products</b>
</NavLink>

<NavLink
  to="/solutions"
  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
  onClick={() => setMenuOpen(false)}
>
  <b>Solutions</b>
</NavLink>

<NavLink
  to="/careers"
  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
  onClick={() => setMenuOpen(false)}
>
  <b>Careers</b>
</NavLink>

<NavLink
  to="/ContactUs"
  className={({ isActive }) =>
    isActive ? 'nav-link active contact-button' : 'nav-link contact-button'
  }
  onClick={() => setMenuOpen(false)}
>
  <b>Contact Us</b>
</NavLink>
          </div>

          <div className="search-container">
            <input type="text" placeholder="Search" className="search-input" />
            <span className="search-icon"><FaSearch /></span>
          </div>
        </div>
      </div>

      <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <span></span><span></span><span></span>
      </div>
      
    </header>
  );
};

export default Header;
